import { Col, Row } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import Alert from '../../../../shared/components/alert/alert';
import LanguageSelect from '../../../../shared/components/language-select/language-select';
import PageTitle from '../../../../shared/components/page-title/page-title';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import styles from '../../../client-users/pages/client-user-trace-logs/client-user-trace-logs.module.css';
import CurrentUserInformationCard from '../../components/current-user-information-card/current-user-information-card';
import CurrentUserPasswordTotpCard from '../../components/current-user-password-totp-card/current-user-password-totp-card';
import { currentUserAlertId } from '../../constants/constants';

const CurrentUserDetails = (): JSX.Element => {
  const { t } = useTranslation('current-user');

  return (
    <AuthGuard>
      <Helmet>
        <title>{t('userInfo.title')}</title>
      </Helmet>
      <LayoutInner>
        <Row justify="space-between" className={styles.headerRow}>
          <Col>
            <PageTitle>{t('userInfo.title')}</PageTitle>
          </Col>
          <Col>
            <LanguageSelect />
          </Col>
        </Row>
        <Alert alertId={currentUserAlertId} />
        <CurrentUserInformationCard />
        <CurrentUserPasswordTotpCard />
      </LayoutInner>
    </AuthGuard>
  );
};
export default CurrentUserDetails;
